import './calendar-card.scss';

/**
 * version    1.0
 * class      <type> (calendar-card)
 * classdesc  Component that manage the page calendar-card
 */
export class CalendarCard {}
